import {
  appendSignupAttributionToUrl,
  appendUtmsToUrl,
  getAttributionUtms,
  getFirstTouchAttribution,
  parseUtmsFromSearch,
  type FirstTouchUtms,
} from '@bookkeeper/shared/first-touch-utm';

const SIGNUP_URL = 'https://app.bookeper.pl/auth/sign-up';

export function getUtmParams(search?: string): FirstTouchUtms {
  return getAttributionUtms(search);
}

/**
 * Build a signup URL that preserves current-URL UTMs across SPA navigations
 * and the www → app redirect, filling missing keys from first-touch memory.
 * `$initial_utm_*` still comes from getFirstTouchAttribution / user_metadata.
 */
export function buildSignupUrl(
  basePath = SIGNUP_URL,
  search?: string,
  options: { firstTouch?: boolean } = {}
): string {
  // firstTouch: false = the query's own UTMs only, no first-touch storage read
  // or write: what the build-time prerender and the hydration pass can know.
  if (typeof search === 'string' && options.firstTouch === false) {
    return appendUtmsToUrl(basePath, parseUtmsFromSearch(search));
  }
  if (typeof search === 'string') {
    return appendSignupAttributionToUrl(
      basePath,
      getAttributionUtms(search),
      getFirstTouchAttribution(search)
    );
  }

  if (typeof window === 'undefined') {
    return basePath;
  }

  return appendSignupAttributionToUrl(
    basePath,
    getAttributionUtms(window.location.search),
    getFirstTouchAttribution(window.location.search)
  );
}
